import ValueInterface, { SerializedValueType } from "./ValueInterface"

export default class BracketedValue implements ValueInterface {
  constructor(private readonly value: ValueInterface) {}

  public toString(): string {
    return `(${this.value.toString()})`
  }

  public normalize(): number {
    return this.value.normalize()
  }

  public clone(): BracketedValue {
    return new BracketedValue(this.value.clone())
  }

  public toJSON(): SerializedValueType {
    return {
      type: "bracketed",
      payload: this.value.toJSON(),
    }
  }
}
